module.exports = __webpack_public_path__ + "img/default-bot-3.42a3e369.png";